import './Skills/_Skill.scss'
import {AiOutlineGithub} from "react-icons/ai";
import Popper from "../Poper";
import SubTitle from "../SubTitle";
import SocialMediaLinks from "../SocialMediaLinks";
import Title from "../Title";
import {skills} from "../../config/data";
import ProfileImage from "./ProfileImage";
import SkillsCards from "./Skills/SkillsCards";
import Animate from "../Animate";
import {gsap} from "gsap";

const About = () => {

  const navigate = (url) => {
    gsap.to(window, {duration: 0, scrollTo: {y: url, offsetY: 100}});
  }

  const calculateXP = (startDate, endDate = new Date()) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diff = end - start;

    if (diff < 0) return "0 yr";

    const years = Math.floor(diff / 31536000000);
    const months = Math.floor((diff % 31536000000) / 2628000000);

    if (years && months) {
      return `${years} yr ${months} mos`;
    } else if (years) {
      return `${years} yr`;
    } else {
      return `${months} mos`;
    }
  };

  return (
      <div id="about" className={'sm:px-2 md:px-5'}>
        <div className={'grid grid-cols-1 md:grid-cols-2 gap-4'}>
          <ProfileImage/>
          <div id='aboutSection' className='sm:pt-0 md:pt-20 px-2'>
            <div>
              <Title title={'About Me'}/>
              <div>
                <Animate direction='up' duration={0.4} delay={0.1} scrollTriggerStart='20% bottom'>
                  <p style={{lineHeight: '30px'}} className={'text-animate text-justify'}>
                    {/*My name is Nahid Ferdous, */}
                    {/*I am a Full-Stack Web Developer from Dhaka, Bangladesh. I
                    help bring your ideas to life and turn your requirements into exciting products.
                    I have completed my BSc (Hons) in computing from Daffodil International Academy
                    (DIA) under the University of Greenwich (UOG UK) in 2021. I specialize in creating
                    robust and interactive websites using technologies like PHP, Laravel, Vue.js, Nuxt.js,
                    Tailwind CSS, etc.
                    I have around {calculateXP('July 2021', new Date())} of experience.*/}

                    I'm a passionate Full-Stack Web Developer from Dhaka, Bangladesh,
                    dedicated to transforming ideas into dynamic, high-performing web applications.
                    With over {calculateXP('July 2021')} of experience,
                    I specialize in building scalable, interactive, and efficient websites using
                    PHP, Laravel, Vue.js, Nuxt.js, Tailwind CSS, and more.
                    <br/>
                    I hold a BSc (Hons) in Computing from Daffodil International Academy (DIA),
                    awarded by the University of Greenwich (UK) in 2021.
                    My expertise lies in crafting seamless user experiences and delivering robust,
                    feature-rich applications that meet business needs.
                    <br/>
                    Let’s build something amazing together! 🚀
                  </p>
                </Animate>
                {/*<div className={'text-center my-6 space-x-4 flex flex-wrap justify-center align-middle'}>*/}
                <Animate direction='up' duration={0.4} delay={0.1} distance={60} scrollTriggerStart='20% bottom'>
                  <div className={'text-center my-6 space-x-2 md:space-x-4 flex flex-wrap justify-start align-middle'}>
                    <button
                        onClick={() => navigate('#contact')}
                        className="hoverLink shadow-lg px-4 md:px-6 py-3 border border-transparent text-base font-medium text-black bg-white rounded-full hover:bg-rose-500  hover:text-white duration-200"
                    >
                      Get In Touch
                    </button>
                    <a href="https://drive.google.com/file/d/1GfBCRYzrduXnudbbfsltAPABmMcDphUs/view?usp=sharing" target='_blank' rel="noreferrer">
                      <button
                          className="hoverLink shadow-lg px-4 md:px-6 py-3 border border-transparent text-base font-medium text-white bg-rose-700 rounded-full hover:bg-rose-500 duration-200"
                      >Resume
                      </button>
                    </a>
                    <a
                        href='https://github.com/nahidnfr123' target='_blank' rel="noreferrer"
                    >
                      <Popper title={'Github'}>
                        <button
                            className="hoverLink shadow-lg px-3 py-3 border-2 border-gray-500 rounded-full bg-transparent hover:text-nfr-color-100 hover:bg-gray-800 hover:dark:bg-gray-900 duration-200"
                        >
                          <AiOutlineGithub className={'text-2xl'}/>
                        </button>
                      </Popper>
                    </a>
                  </div>
                </Animate>
                <div className={'mt-10'}>
                  <SubTitle title='Want to socialise ?'/>
                  <div className={'ml-6 mt-4'}>
                    <SocialMediaLinks/>
                  </div>
                </div>
              </div>
            </div>

            {/* Skills */}
            {skills && skills.development &&
                <div className={'py-20'}>
                  <Title title={'Skills'}/>
                  <div>
                    <SubTitle title='Development Skills'/>
                    <SkillsCards developmentSkills={skills.development}/>
                  </div>
                </div>
            }
          </div>
        </div>

        <div className={'grid grid-cols-1 md:grid-cols-2 gap-10 px-2'}>
          {/* Design Skills */}
          <div>
            <SubTitle title='Design Skills'/>
            <SkillsCards developmentSkills={skills.design}/>
            {/*<ul className={'skillUl flex gap-1 md:gap-4 flex-wrap text-center justify-center md:justify-start mt-4'}>
              {skills && skills.design && skills.design.map(({name, icon}, i) => (
                  // <li key={i} className='drop-shadow-xl shadow-bg-nfr-color-900 bg-nfr-color-200 dark:bg-nfr-color-800'>
                  <Animate key={i} direction='up' duration={0.4} delay={0.1 * i} distance={60} scrollTriggerStart='20% bottom'>
                    <SkillCard name={name}/>
                  </Animate>
              ))}
            </ul>*/}
          </div>
          {/* Other Skills */}
          <div>
            <SubTitle title='Others'/>
            <Animate direction='up' duration={0.4} delay={0.1} distance={60} scrollTriggerStart='20% bottom'>
              <ul className={'mt-4 pl-4'}>
                {skills && skills.others && skills.others.map(({name}, i) => (
                    <li key={i} className={'my-1 otherSkill'} style={{fontSize: 'var(--fz-sm)'}}>- {name}</li>
                ))}
              </ul>
            </Animate>
          </div>
        </div>
      </div>);
}

export default About;
